<form class="mce-form-section">

    <div class="mce-form-section-title">Cable Selection</div>

    <div class="mce-form-field-group">

        <div class="flex min-w-0 flex-grow flex-col">

            <div class="flex-grow" [class.mce-form-field-disabled]="cablesRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>manufacturers</mat-label>
                    <mat-select [formField]="form().selectedCable.manufacturerGuid">
                        @for (option of selects().manufacturers; track option.guid) {
                        <mat-option [value]="option.guid">{{option.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="flex-grow" [class.mce-form-field-disabled]="cablesRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>cable type</mat-label>
                    <mat-select [formField]="form().selectedCable.sourceGuid">
                        @for (option of selects().sources; track option.source.guid) {
                        <mat-option [value]="option.source.guid">{{option.source.description}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

        </div>

        <div class="flex flex-col">

            <div class="hidden sm:flex">
                <app-form-image [formImage]="viewState().logo"></app-form-image>
            </div>

            <div>
                <mat-checkbox matTooltip="Disable Voltage Filter, allows higher rated voltage cables to be shown.  Use if you need to select a cable with a rated voltage higher than would normally be chosen. "
                              [formField]="form().settings.disableVoltageFilter">Disable Voltage Filter</mat-checkbox>
            </div>

        </div>


    </div>


    <div class="mce-form-field-group">

        <div [class.mce-form-field-disabled]="cablesRx.isLoading()">
            <mat-form-field class="w-full">
                <mat-label>select cable</mat-label>
                <mat-select [formField]="form().selectedCable.libraryGuid">
                    @for (option of selects().libraries; track option.guid) {
                    <mat-option [value]="option.guid">{{option.description}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div [class.mce-form-field-disabled]="cablesRx.isLoading()">
            <mat-form-field class="w-full">
                <mat-label>csa</mat-label>
                <mat-select [formField]="form().selectedCable.csa">
                    @for (option of selects().csas; track option) {
                    <mat-option [value]="option">{{option}}  mm²</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

    </div>


</form>
